import { useTranslation } from '@/hooks/support/translate';
import { MissionHubTaskV2 } from '@/utils/http/get-mission-tasks';
import classNames from 'classnames';
import { FC } from 'react';
import { Button } from '../atom/Button';

interface MissionHubTaskProps {
    mission: MissionHubTaskV2;
    points?: number;
    onClick?: () => void;
    isDisabled?: boolean;
    ctaLabel?: string;
}

export const MissionHubTask: FC<MissionHubTaskProps> = (props) => {
    const { mission, onClick, points, isDisabled, ctaLabel } = props;
    const { t } = useTranslation();

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (mission.cta) {
            window.open(mission.cta, '_blank');
        }
    };

    return (
        <div
            className={classNames(
                'relative flex flex-col first-line:ps-card p-4 pt-6 rounded-lg card card__border bg-[#1b1423] min-h-[276px] justify-between',
                {
                    'pointer-events-none': mission.isEnded,
                },
            )}
        >
            {mission.isNew && !mission.isEnded && (
                <div className="shadow absolute right-4 -top-3 py-1 px-2 text-[10px] font-bold tracking-wide uppercase text-white rounded bg-gradient-to-r from-[#e50146] to-[#4929ad]">
                    {t('modal.pointsSystem.card.new')}
                </div>
            )}
            {mission.isEnded && (
                <div className="shadow absolute right-4 -top-3 py-1 px-2 text-[10px] font-bold tracking-wide uppercase rounded bg-grey-40">
                    {t('modal.pointsSystem.card.ended')}
                </div>
            )}
            <div
                className={classNames({
                    '-z-50 absolute w-40 top-20 bottom-0 right-0 rounded-lg': !mission.isEnded,
                })}
            ></div>
            <div className="flex flex-col items-center h-full mb-5 text-center">
                <div className="text-white t--body--b2">{mission.title}</div>
                <div
                    className={classNames('t__heading--h5 z-10 mt-8', {
                        'text-[#ffc635]': points && points > 0,
                        'text-white': points === 0 || mission.isEnded,
                    })}
                >
                    {points ? Math.floor(points) : 0}
                </div>
                <div className="z-50 mt-8 t__body--b3 text-grey-20">{mission.description}</div>
            </div>
            {(ctaLabel || mission.ctaLabel) && (onClick || mission.cta) && (
                <div className="mt-auto">
                    <div className="flex flex-col flex-grow-0 w-full">
                        <Button
                            variant="primary-mission-hub"
                            isDisabled={mission.isEnded || isDisabled}
                            className="flex justify-center"
                            onClick={handleClick}
                            size="large"
                        >
                            <span className="capitalize">{ctaLabel || mission.ctaLabel}</span>
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
};
